import { createFileRoute } from "@tanstack/react-router";

import { TrainingScreen } from "../features/training/components/TrainingScreen.tsx";

export const Route = createFileRoute("/_app/training")({
  component: TrainingScreen,
});
